<template>
    <div class="onboarding-top-nav-container">
        <div class="content">
            <div class="left-side">
                <div class="logo-container">
                    <div class="logo">
                        <img src="../../../images/logo-symbol-white.svg" alt="Logo" />
                    </div>
                </div>
                <NavBarPill label="Back to templates" icon-name="back" @button-clicked="goBack()" />
            </div>
            <div class="right-side">
                <div class="ufo--device-switch">
                    <button @click="changeViewMode('desktop')" :class="{'active' : viewMode === 'desktop'}">
                        <Icon icon-name="desktop_preview" />
                    </button>
                    <button @click="changeViewMode('mobile')" :class="{'active' : viewMode === 'mobile'}">
                        <Icon icon-name="mobile_preview" />
                    </button>
                </div>
                <Cta @click="handleClick">Start building</Cta>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from "@/scripts/common/Icon.vue";
    import NavBarPill from "@/scripts/common/editorNavBar/NavBarPill.vue";
    import Cta from "@/scripts/common/components/CtaButton.vue";

    export default {
        name: "OnboardingTopNav",
        props:['viewMode'],
        components: {
            Cta,
            NavBarPill,
            Icon
        },
        methods: {
            changeViewMode(mode) {
                this.$emit('changeViewMode', mode);
            },
            goBack() {
                this.$emit('goBack')
            },
            handleClick() {
                this.$emit('setPortfolioTheme');
            }
        }
    }
</script>

<style scoped lang="scss">
    .onboarding-top-nav-container {
        border-bottom: 1px solid var(--asphalt20);

        .content {
            padding: 8px 20px;
            display: flex;
            align-content: center;
            align-items: center;
            justify-content: space-between;
            max-width: 2440px;
            margin-left: auto;
        }

        .left-side {
            display: flex;
            align-items: center;
            gap: 24px;
        }

        .right-side {
            display: flex;
            align-items: center;
            gap: 24px;

            .ufo--device-switch {
                display: flex;
                align-items: flex-start;
                gap: 2px;
                border-radius: 8px;
                border: 1px solid var(--asphalt20);
                background: var(--asphalt20);
                padding: 4px;
                width: max-content;

                button {
                    display: flex;
                    padding: 10px;
                    justify-content: center;
                    align-items: center;
                    gap: 2px;
                    border-radius: 4px;
                    outline: none;
                    border:none;
                    cursor: pointer;

                    svg {
                        color: var(--asphalt40);
                    }

                    &:hover {
                        svg {
                            color: var(--asphalt60);
                        }
                    }
                    &.active {
                        background-color: var(--asphalt10);
                        box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.09), 0 0 1px 0 rgba(0, 0, 0, 0.10);
                        svg {
                            color: var(--asphalt80);
                        }
                    }
                }
            }
        }
    }
</style>